import { GRID_COLS, GRID_ROWS, TILE_SIZE, CELL } from './config';

export const HALF = TILE_SIZE / 2;
export const GAME_W = GRID_COLS * TILE_SIZE;
export const GAME_H = GRID_ROWS * TILE_SIZE;
export const IS_MOBILE = /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const DIR = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] };
export const OPPOSITE = { up: 'down', down: 'up', left: 'right', right: 'left' };

export const C = {
  bg: 0x000000,
  wall: 0x1a3a8a,
  wallStroke: 0x4488ff,
  corridor: 0x111111,
  hub: 0x0a1a3a,
  hubDoor: 0xff88aa,
  tunnel: 0x1a0a2a,
  pill: 0xffdd00,
  powerup: 0x4488ff,
  player: 0xffdd00,
  playerStroke: 0xff8800,
  bonus: 0xffd700,
  enemies: { blinky: 0xff0000, pinky: 0xff69b4, inky: 0x00bfff, clyde: 0xff8c00 },
  scared: 0x2222ff,
  scaredBlink: 0xffffff,
};

export function tx(col) { return col * TILE_SIZE + HALF; }
export function ty(row) { return row * TILE_SIZE + HALF; }
